module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/user-session-store-connect/~/babel-runtime/core-js/object/define-property.js
// module id = 238
// module chunks = 0 1